import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import CssBaseline from "@material-ui/core/CssBaseline";
import { KSnackbar } from "@kyburz/kdesign-system";
import KLoader from "../components/ui/KLoader";
import Navigation from "../components/navigation/Navigation";
import { privateRoutes, publicRoutes } from "../routes";
import { defaultCustomer } from "../components/constants/defaultCustomer";
import { getCustomer, isAuthenticated } from "../apiCalls/auth";
import {
  setUser,
  clearUser,
  clearAlert,
  setCustomer,
} from "../redux/actions/actions";

import "typeface-roboto";
// import 'ace-builds/webpack-resolver';

import "./App.css";
import { RootStateInterface } from "../interfaces/ReduxInterface";

const App = () => {
  const isLoggedIn = useSelector(
    (state: RootStateInterface) => state.user.isLoggedIn,
  );
  const dispatch = useDispatch();

  const routes = isLoggedIn ? privateRoutes : publicRoutes;

  const alert = useSelector((state: RootStateInterface) => state.alert);

  const handleClose = () => dispatch(clearAlert());

  const currentCustomer =
    JSON.parse(localStorage.getItem("currentCustomer") || "{}") || null;

  const getCustomerData = () => {
    if (currentCustomer?.shortname) {
      getCustomer(currentCustomer?.shortname).then((res) => {
        dispatch(setCustomer(res.data));
      });
    }
  };

  useEffect(() => {
    if (currentCustomer?.shortname) {
      getCustomerData();
    }
  }, []);

  useEffect(() => {
    isAuthenticated()
      .then((res) => {
        if (res.user) {
          dispatch(setUser(res.user));
        } else {
          dispatch(clearUser());
        }
      })
      .catch((err) => {
        dispatch(clearUser());
        console.error(err);
      });
  }, [isLoggedIn]);

  useEffect(() => {
    if (!localStorage.getItem("currentCustomer")) {
      localStorage.setItem("currentCustomer", JSON.stringify(defaultCustomer));
    }
  }, []);

  return (
    <>
      <CssBaseline />
      {isLoggedIn === null ? (
        <KLoader />
      ) : (
        <Router>
          <div className="app__background">
            {isLoggedIn && <Navigation />}
            <div className="app__content">{routes}</div>
          </div>
        </Router>
      )}
      <KSnackbar
        open={alert.open}
        severity={alert.severity}
        text={alert.text}
        handleClose={handleClose}
      />
    </>
  );
};

export default App;
